import { render } from "./MultiTopicNav.vue?vue&type=template&id=58faab91"
import script from "./MultiTopicNav.vue?vue&type=script&lang=js"
export * from "./MultiTopicNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__